// CJS interop: Vite prebundles this package as
// `export default require_dist()` where require_dist() returns the whole
// CJS exports object, so the actual component is at `.default` instead of
// being the default itself.
import type { ReactElement } from 'react';
import FacebookLoginPkg, {
  type FacebookLoginProps,
  type SuccessResponse,
} from '@greatsumini/react-facebook-login';
const FacebookLogin = (FacebookLoginPkg as unknown as {
  default: (props: FacebookLoginProps) => ReactElement;
}).default;
import { useTranslation } from 'react-i18next';
import { FaFacebookF } from 'react-icons/fa6';
import { useFacebookLogin } from '../../api/queryHooks/user';
import { useAccountInfo } from '../../api/queryHooks/account';
import { Loader } from '@f2m3/shared-frontend-ui';
import './socialLoginButtons.scss';

const FacebookButton = () => {
  const { t } = useTranslation();
  const { mutate: loginWithFacebook, isPending } = useFacebookLogin();
  const { data: accountInfo } = useAccountInfo();

  const fb = accountInfo?.setting?.facebook_login;
  // Per-shop config gates this button: no central app id anymore. Hidden unless
  // the shop admin configured a Facebook app (id + secret => enabled).
  if (!fb?.enabled || !fb.app_id) return null;

  if (isPending) return <Loader />;

  return (
    <FacebookLogin
      appId={fb.app_id}
      onSuccess={(response: SuccessResponse) => {
        loginWithFacebook({ accessToken: response.accessToken });
      }}
      onFail={() => {}}
      render={(renderProps: { onClick?: () => void }) => (
        <button onClick={renderProps.onClick} className="button is-facebook">
          <span className="icon">
            <FaFacebookF />
          </span>
          <span>{t('login.button_facebook')}</span>
        </button>
      )}
    />
  );
};

export default FacebookButton;
